module.exports = __webpack_public_path__ + "static/img/sc21.612f48d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/sc21.png
// module id = iuOh
// module chunks = 25